import { Component }    from '@angular/core';
import { Router }       from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { fadeInAnimation } from '../animations/index';
import { environment }  from '../../environments/environment';
import { UserService }  from '../services';
import { User }         from '../models';

@Component({
    selector: 'navigation-component',
    templateUrl: '../templates/navigation.component.html'
})
export class NavigationComponent {

  public user: User = null;

  constructor(private authService: OAuthService, private router: Router, private userService: UserService) {
    this.authService.loginUrl = environment.loginUrl;
    this.authService.logoutUrl = environment.logoutUrl;
    this.authService.redirectUri = environment.redirectUri;
    this.authService.userinfoEndpoint = environment.userinfoEndpoint;
    this.authService.clientId = environment.clientId;
    this.authService.oidc = false;

    userService.user$.subscribe(
      user => {
        this.user = user;
      });
  }

  login() {
    this.authService.initImplicitFlow();
  }

  logout() {
    this.authService.logOut(true);
    this.userService.changeUser(null);
    this.router.navigate(['/']);
  }

  ngOnInit() {
    this.authService.tryLogin({});
    if (this.authService.hasValidAccessToken()) {
      this.authService.loadUserProfile().then(
        () => this.userService.changeUser(new User(this.authService.getIdentityClaims()))
      );
      this.router.navigate(['/exports']);
    } else {
      this.logout();
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/components/navigation.component.ts